export function request(query) {
    return {
        type: 'PAYMENTS_SEARCH_REQUEST',
        query
    };
}

export function error(errors) {
    return {
        type: 'PAYMENTS_SEARCH_ERROR',
        errors
    };
}

export function finish(data, aggregations) {
    return {
        type: 'PAYMENTS_SEARCH_FINISH',
        data,
        aggregations
    };
}

export function clear() {
    return {
        type: 'PAYMENTS_SEARCH_CLEAR'
    };
}
